// This is the webpack entry point
// Refrain from putting actual code in here and just import the modules you need;
import './components/nav';
import './components/modal';
import './blocks/resources-carousel/resources-carousel';
import './blocks/resources-feed/index';
import './blocks/events-feed/index';

import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';
